<div class="custom-dialog figma-dialog">
  <div class="container d-justify-bw">
    <div class="custom-dialog__left">
      <div class="mat-dialog-title custom-dialog__title flex-row-between">
        <div class="title">
          <h3 class="title-text" *ngIf="!showErrorIcon">{{customTitle || content?.toastMessageList[0]?.title || 'Some of the profiles could not be uploaded'}}</h3>
        </div>
        <div class="close" *ngIf="!showViewBtn">
          <button mat-icon-button aria-label="Close dialog" (click)="closeDialog()">
            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
          </button>
        </div>
      </div>

      <mat-dialog-content class="custom-dialog__text">
        <!-- File invalid variant: centered icon + title + description -->
        <div *ngIf="showErrorIcon" class="file-error-content">
          <mat-icon class="file-error-icon" fontSet="material-symbols-outlined">error</mat-icon>
          <h3 class="title-text">{{customTitle || content?.toastMessageList[0]?.title || 'File could not be uploaded'}}</h3>
          <span class="description">{{customMessage || content?.toastMessageList[0]?.description}}</span>
        </div>

        <div *ngIf="!showErrorIcon" class="title-wrapper">
          <span *ngIf="!showViewBtn" class="description">{{customMessage || content?.toastMessageList[0]?.description}}</span>
          <span *ngIf="showViewBtn" class="description">
            {{ getFailedProfilesText() }} You can view the list of employees that were not uploaded.
          </span>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions class="upload-action" style="justify-content: flex-end;">
        <button mat-button class="button--secondary-small" *ngIf="!showErrorIcon" (click)="closeDialog()">{{ content?.warningList?.[6]?.confirmCTAText }}</button>
        <button mat-button class="button--primary-small" *ngIf="showErrorIcon" (click)="closeDialog()">{{ctaText || 'Try again'}}</button>
        <button *ngIf="showViewBtn" mat-button class="button--primary-small" style="margin-left: 10px;" (click)="viewDetails()">{{policyContent?.['b2b.managepolicy.view'] || 'View'}}</button>
      </mat-dialog-actions>
    </div>
  </div>
</div>


